
import {defineComponent, Prop} from 'vue';
import InfigoAddress from "@/types/demo/address";
import AddressState from "@/services/cache/address-state";

export default defineComponent({
  emits: ['address-change'],
  props: {
    address: Object as Prop<InfigoAddress>
  },
  data() {
    return {
      countries: [
        'United States', 'Canada', 'United Kingdom', 'Australia', 'Germany',
        'France', 'Spain', 'Italy', 'Netherlands', 'Brazil',
        'India', 'China', 'Japan', 'Mexico', 'South Africa',
        // Add more countries as needed
      ],
    };
  },
  methods: {
    clearForm(){
      this.$emit('address-change', AddressState.getDefaultAddress());
    },
    updateAddress(field: string, value: string) {
      const newAddress = {
        ...this.address,
        [field]: value
      }
      this.$emit('address-change', newAddress);
    },
    submitAddress() {
      const newAddress = {
        ...this.address
      }
      console.log('Address submitted:', newAddress);
      this.$emit('address-change', newAddress);
    },
  },
});
